import { render, staticRenderFns } from "./LiveClassItem.vue?vue&type=template&id=b2f96652&scoped=true"
import script from "./LiveClassItem.vue?vue&type=script&lang=js"
export * from "./LiveClassItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f96652",
  null
  
)

export default component.exports